<template>
  <component
    :is="category !== null && tid ? 'nuxt-link' : 'div'"
    :to="`/search?sort_by=created${jurisdictionQuery}${subjectQuery}`"
    class="range"
  >
    <div class="range__bar">
      <span :style="'width: ' + (width + 2) + '%'" :class="colorBar" />
    </div>
    <div class="range__text">{{ text }}</div>
  </component>
</template>

<script>
export default {
  name: "Range",
  props: {
    text: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: null,
    },
    category: {
      type: [Number, String],
      default: null,
    },
    tid: {
      type: Number,
      default: null,
    },
    jurisdiction: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    topic: {
      type: Number,
      default: null,
    },
  },
  computed: {
    colorBar() {
      let color = null;
      if (this.width < 33) {
        color = "lightblue";
      } else if (this.width < 66) {
        color = "medblue";
      } else {
        color = "blue";
      }
      return color;
    },
    jurisdictionQuery() {
      return this.jurisdiction && this.type !== "jurisdictions"
        ? `&filter[jurisdictions][]=${this.jurisdiction}`
        : "";
    },
    subjectQuery() {
      return this.category !== null && this.tid
        ? `&filter[${this.type}][]=${this.tid}`
        : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.range {
  $el: &;

  display: flex;
  align-items: center;
  color: $text_gray;
  text-decoration: none;
  transition: color 0.3s;

  @at-root {
    a#{$el}:hover {
      color: $corporateBlue;
    }
  }

  &__bar {
    $width: 5.8rem;

    width: $width;
    min-width: $width;
    height: 1rem;
    margin-right: 2rem;
    border-radius: 5px;
    border: 1px solid #d6c2c2;
    position: relative;

    span {
      position: absolute;
      left: -1px;
      top: -1px;
      height: calc(100% + 2px);
      border-radius: 5px;
      display: block;

      &.blue {
        background: $brightBlue;
      }

      &.medblue {
        background: lighten($brightBlue, 20%);
      }

      &.lightblue {
        background: lighten($brightBlue, 30%);
      }
    }
  }

  &__text {
    font-size: 1.5rem;
    font-weight: 700;
    color: currentColor;
  }
}
</style>
